import React from "react";
import { Auth } from "../helpers/auth";

function SunIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" aria-hidden="true">
      <circle cx="12" cy="12" r="4.2" />
      <path d="M12 2.5v2.4M12 19.1v2.4M2.5 12h2.4M19.1 12h2.4M5.3 5.3l1.7 1.7M17 17l1.7 1.7M18.7 5.3 17 7M7 17l-1.7 1.7" />
    </svg>
  );
}

function MoonIcon() {
  return (
    <svg width="14" height="14" viewBox="0 0 24 24" fill="currentColor" aria-hidden="true">
      <path d="M20.5 14.6A8.6 8.6 0 0 1 9.4 3.5a.6.6 0 0 0-.8-.7 9.8 9.8 0 1 0 12.6 12.6.6.6 0 0 0-.7-.8z" />
    </svg>
  );
}

export default function Topbar({
  title,
  isMenuOpen = false,
  onToggleMenu,
  theme = "dark",
  onToggleTheme,
}) {
  return (
    <header className="topbar">
      <button
        type="button"
        className={`hamburger ${isMenuOpen ? "is-open" : ""}`}
        aria-label={isMenuOpen ? "Collapse menu" : "Expand menu"}
        aria-expanded={isMenuOpen}
        onClick={onToggleMenu}
      >
        <svg width="22" height="22" viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M4 7h16M4 12h16M4 17h16"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
          />
        </svg>
      </button>

      <div className="topTitle">{title}</div>

      <div className="topActions">
        <button
          type="button"
          className="themeToggle"
          role="switch"
          aria-checked={theme === "light"}
          aria-label="Light theme"
          title={theme === "light" ? "Switch to dark" : "Switch to light"}
          onClick={onToggleTheme}
        >
          <span className="themeToggle__thumb">
            {theme === "light" ? <SunIcon /> : <MoonIcon />}
          </span>
        </button>
        <button
          className="btn copytext"
          onClick={async () => {
            await Auth.logout();
            window.location.href = "/signin";
          }}
        >
          Sign out
        </button>
      </div>
    </header>
  );
}
